// extracted by mini-css-extract-plugin
export default {"steps":"styles_steps__3z8zl","step":"styles_step__hjbwM","current":"styles_current__lLSU6","complete":"styles_complete__BUUdZ","text":"styles_text__aOSu9"};